import { clsx } from "clsx";
import { useUserStore } from "@/common/store/userStore";
import { SORT_OPTIONS } from "./constants";
import { AddNicheBtn } from "@/components/niches/AddNicheBtn";
import { SortBySelect, IItemList } from "@/components/UI/SortBySelect/SortBySelect";
import "./NicheFeedControls.scss";

interface INicheFeedControls {
  order: string;
  changeOrder: (value: string | null) => void;
  sortOptions?: IItemList[];
  size?: "m" | "l";
}

export const NicheFeedControls = ({ order, changeOrder, sortOptions, size }: INicheFeedControls) => {
  const user = useUserStore((state) => state.currentUser?.username);

  return (
    <div className={clsx("nicheFeedControls", !user && "nicheFeedControlsEnd")}>
      <AddNicheBtn />
      <SortBySelect
        label="Sort by"
        size={size}
        list={sortOptions || SORT_OPTIONS}
        value={order}
        onChange={changeOrder}
      />
    </div>
  );
};
